// @flow
export const menuBarActions = {
  Set_Column_Wise_Routes: "Set_Column_Wise_Routes",
  Show_Hide_MenuBar: "Show_Hide_MenuBar"
};

export const setColumnWiseRoutes = (data: Array<any>) => ({
  type: menuBarActions.Set_Column_Wise_Routes,
  payload: data
});

export const toggleMenuBarDisplay = (data: boolean) => ({
  type: menuBarActions.Show_Hide_MenuBar,
  payload: data
});



// WEBPACK FOOTER //
// ./app/components/commons/menuBar/menuBarRedux/menuBarActionCreator.js